/**
 * Convert the data from Difficulty into an object array
 *
 * @param entry
 * @returns {{easierTitle: "", easierList: [], harderTitle: "", harderList: []}[]}
 */
export default function getProgramObjectiveListData(entry, t) {
  if (!entry) return null

  const data = []
  const trainings = entry.trainings

  if (trainings) {
    const listData = []
    const objectiveData = {}
    trainings.map((training) => {
      if (training.objectiveCategories) {
        const title = training.objectiveCategories[0].title
        objectiveData[title] = objectiveData[title] ? objectiveData[title] + 1 : 1
      }
      return ''
    })

    Object.keys(objectiveData)
      .sort()
      .forEach((label) => {
        listData.push({ li: `${objectiveData[label]}x ${t('DETAIL_CARD__TEAMTASK')} ${label.toLowerCase()}` })
      })

    data.push({ ul: listData })
  }

  return data
}
